import ServiceBrokerCaller from "./serviceBrokerCaller";
import { Env } from '@stencil/core';

interface ModuleInfo {
  dependencies?: {
    turnkey?: {
      version?: string;
    };
  };
}

export default class ModuleInfoUtils {

  private static MODULE_INFO_CACHE: ModuleInfo | null = null;
  private static readonly MELHORES_PRATICAS_CREDENCIAMENTO_BOLETO_MIN_VERSION = Env.MIN_VERSION_TURNKEY_CREDENCIAMENTO_BOLETO;

  public static async melhoresPraticasCredenciamentoBoletoAtivo(): Promise<boolean> {
    const moduleInfo = await this.fetchModuleInfo();

    if(moduleInfo == null) return false;

    const turnkeyVersion = moduleInfo?.dependencies?.turnkey?.version || null;

    if(!turnkeyVersion) return false;

    return this.isMinVersion(turnkeyVersion, this.MELHORES_PRATICAS_CREDENCIAMENTO_BOLETO_MIN_VERSION);
  }

  public static async fintechModuleExists(): Promise<boolean> {
    const moduleInfo = await this.fetchModuleInfo();
    return moduleInfo != null;
  }

  private static async fetchModuleInfo(): Promise<ModuleInfo | null> {
    if (this.MODULE_INFO_CACHE) {
      return this.MODULE_INFO_CACHE;
    }

    try {
      const response = await ServiceBrokerCaller.callService('devex-jnm-webcom81@ModuleInfoSP.getModuleInfo', {});
      this.MODULE_INFO_CACHE = response;
      return { ...this.MODULE_INFO_CACHE };
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  private static isMinVersion(versionA: string, versionB: string): boolean {
    if (!versionA || !versionB) return false;

    versionA = versionA.replace(/[A-Za-z]/g, '')
      .replace(/\D/g, '');
    
    versionB = versionB.replace(/[A-Za-z]/g, '')
      .replace(/\D/g, '');

    const splitA = parseFloat(versionA);
    const splitB = parseFloat(versionB);

    return splitA >= splitB;
    
  }
}